module.exports = __webpack_public_path__ + "img/MIGRATION.6b4e3e95.svg";